module.exports = __webpack_public_path__ + "static/media/product-4.b0cdec00.png";